import vue from '../../main'
import * as insure from '../index'
import { baseUrl } from "../../request/url";
let _this = vue;
let token
//登录
export function login($this) {
    let sendData = new FormData();
    sendData.append("userName", $this.companyName);
    _this.$api.Insurance.YangGuangControllersLogic(sendData).then((res) => {
        if (res.error === false) {
            token = res.data;
            console.log(token);
        } else {
            // _this.login();
            _this.$message.error(res.msg);
        }
    });
}

// 注册
export function register($this) {
    console.log($this);
    let sendData = new FormData();
    sendData.append("userName", $this.companyName);
    _this.$api.Insurance.YangGuangRegister(sendData).then((res) => {
        if (res.error === false) {
            // login($this);
        } else if (res.code === 1 && res.msg.indexOf("认证失败") != -1) {
            setTimeout(() => {
                register($this)
            }, 1000);
        }
        else {
            _this.$message.error(res.msg);
        }
    });
}

// 登录并注册
export function reg_log($this) {
    console.log($this);
    let sendData = new FormData();
    sendData.append("userName", $this.companyName);
    _this.$api.Insurance.YangGuangRegister(sendData).then((res) => {
        if (res.error === false) {
            login($this);
        } else if (res.code === 1 && res.msg.indexOf("认证失败") != -1) {
            setTimeout(() => {
                reg_log($this)
            }, 1000);
        } else if (res.code === 1 && res.msg.indexOf("已存在") != -1) {
            login($this);
        } else {
            _this.$message.error(res.msg);
        }
    });
}

//新增投保单位 
export function EnterpriseEdit(res, id, $this) {
    let flag = res;
    // 新增
    let sendData = res;
    sendData.token = $this.token;
    // 有第三方信息就传入id进行编辑
    sendData.code = res.creditCode;
    sendData.businessLicenseJson = "https:" + res.businessLicencePath;
    sendData.cityCode = res.provincialandCivicCode.split(",")[2];
    sendData.zipCode = res.postcode;
    sendData.username = $this.$store.state.companyName;

    $this.$api.Insurance.YangGuangEnterpriseAdd(sendData).then((res) => {
      
        if (res.error === false) {
            $this.insuredCompanyId = res.data;
            insure.MatchingUnitInfo(res, id, $this);
            OrderPrePerson($this);
        } else {
            $this.$message.error(res.msg);
            $this.submitLoading = false;
        }
    });

}



//预处理人员
export function OrderPrePerson($this) {
    let personList = [];
    $this.tableData.forEach((item) => {
        let obj = {};
        obj.idcard = item.identityCard;
        obj.name = item.cname;
        obj.workTypeCode = item.workTypeCode;
        obj.healthy = item.healthy;
        personList.push(obj);
    });

    let sendData = {
        username: $this.companyName,
        insurancePlanItemId: $this.detail.thirdlyId,
        insuredCompanyId: $this.insuredCompanyId,
        personList: personList,
    };
    $this.$api.Insurance.OrderPrePerson(sendData).then((res) => {
        $this.submitLoading = false;

        if (res.error === false) {
            $this.orderFlag = true;
            // thirdpartyInsuranceKey 第三方的key
            $this.thirdpartyInsuranceKey = res.data;
        } else {
            $this.orderFlag = true;

            $this.$message.error(res.msg);
        }
    });
}

//获取订单详情
export async function GetOrderInfo(param, item) {
    //param:请求参数(公司名，订单编号)
    //item: 每一条数据
    let sendData = param;
    //获取订单详情
    await this.$api.Insurance.GetOrderInfo(sendData).then(async (res) => {
        if (res.error === false) {
            //subOrderList 第三方存储我方的批单编号列表
            if (res.data.subOrderList && res.data.subOrderList.length > 0) {
                // 检查是否需要添加批单
                this.CheckOrderNo(res.data, item);
            }
            // 同步第三方信息
            await this.SynchronizationThirdlyInfo(item, res.data);
        } else {
        }
    });
}


//跳转到中意新增和编辑页
export function editWeb($this, orderNo) {
    let href = `${baseUrl.sunlightWebsite}/authorization?token=${token}&redirectPage=/order/edit&policyCompanyId=${$this.insuredCompanyId}&insuredCompanyId=${$this.insuredCompanyId}&preAddPersonKey=${$this.thirdpartyInsuranceKey}&insurancePlanItemId=${$this.detail.thirdlyId}&outTradeNo=${orderNo}`;
    window.open(href, "_blank");
}